module.exports = __webpack_public_path__ + "img/LogoSisloc.ee20bdad.png";